module.exports = __webpack_public_path__ + "static/media/ref.e28bc16a.png";